import { render, staticRenderFns } from "./RadioOnIcon.vue?vue&type=template&id=115a90ea"
import script from "./RadioOnIcon.vue?vue&type=script&lang=ts"
export * from "./RadioOnIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports